import {
  colecaoDisponivelSchema,
  type ColecaoDisponivel,
} from "@base/contracts";

const CHAVE = "renke-refs.colecoes-disponiveis";
const CHAVE_EM = "renke-refs.colecoes-disponiveis-em";

/**
 * Ultima lista de colecoes vistas nesta aba — para pintar a tela na hora
 * enquanto o Instagram atualiza em segundo plano.
 */
export function lerCacheColecoesDisponiveis(): {
  readonly dados: readonly ColecaoDisponivel[];
  readonly atualizadoEm: number;
} | null {
  try {
    const bruto = sessionStorage.getItem(CHAVE);
    const em = sessionStorage.getItem(CHAVE_EM);
    if (!bruto || !em) return null;
    const dados = colecaoDisponivelSchema.array().parse(JSON.parse(bruto));
    const atualizadoEm = Number(em);
    if (!Number.isFinite(atualizadoEm)) return null;
    return { dados, atualizadoEm };
  } catch {
    return null;
  }
}

export function gravarCacheColecoesDisponiveis(
  dados: readonly ColecaoDisponivel[],
): void {
  try {
    sessionStorage.setItem(CHAVE, JSON.stringify(dados));
    sessionStorage.setItem(CHAVE_EM, String(Date.now()));
  } catch {
    // storage cheio / privado - ignora
  }
}

/** Remove a lista em cache desta aba (ex.: Instagram desconectado). */
export function limparCacheColecoesDisponiveis(): void {
  try {
    sessionStorage.removeItem(CHAVE);
    sessionStorage.removeItem(CHAVE_EM);
  } catch {
    // storage bloqueado - ignora
  }
}
